import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export const RecommendationSkeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={cn(styles['skeleton'], styles['image'])} />
      <div className={cn(styles['skeleton'], styles['short'])} />
      <div className={styles['skeleton']} />
      <div className={styles['skeleton']} />
    </div>
  );
};
